import { Box, Typography } from '@mui/material';

import { styles } from './styles';

interface IPaymentSummaryBoxProps {
  totalAmount: string;
  items: Array<{
    label: string;
    amount: string;
  }>;
  taxAmount?: number;
  currency?: string;
  headerText?: string;
  width?: string | number;
}

function PaymentSummaryBoxComponent({
  totalAmount,
  items,
  currency = '£',
  headerText,
  width,
}: IPaymentSummaryBoxProps) {
  return (
    <Box sx={{ ...styles.container, width: width || styles.container.width }}>
      <Box>
        <Typography sx={styles.headerText}>
          {headerText || 'Total to pay:'}
        </Typography>
        <Typography sx={styles.totalAmount}>
          {currency}
          {Number(totalAmount).toFixed(2)}
        </Typography>
        {items?.map((item, index) => (
          <Box key={index} display="flex" justifyContent="space-between">
            <Typography sx={styles.itemText}>{item?.label}</Typography>
            <Typography sx={styles.itemText}>
              {currency}
              {Number(item?.amount).toFixed(2)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default PaymentSummaryBoxComponent;
